import Service from "./Service";

class AdministrationApiService extends Service {
  constructor() {
    super("api/Administration");
  }

  async getStops() {
    let result = await this.get(`/Stops`, (status, data) => {
      return data;
    });
    return result;
  }
}

export default new AdministrationApiService();
